/*!

=========================================================
* Vuetify Material Dashboard - v1.0.0
=========================================================

* Product Page: https://www.creative-tim.com/product/vuetify-material-dashboard
* Copyright 2019 Creative Tim (https://www.creative-tim.com)
* Licensed under MIT (https://github.com/creativetimofficial/vuetify-material-dashboard/blob/master/LICENSE.md)

* Coded by Creative Tim

=========================================================

* The above copyright notice and this permission notice shall be included in all copies or substantial portions of the Software.

*/

// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'

// Components
import './components'

// Plugins
import './plugins'
// Sync router with store
import { sync } from 'vuex-router-sync'

// Application imports
import App from './App'
import i18n from '@/i18n'
import router from '@/router'
import store from '@/store'

import Toasted from 'vue-toasted';

import vSelect from 'vue-select'
import 'vue-select/dist/vue-select.css';



import VueFilterDateFormat from 'vue-filter-date-format';



Vue.component('v-select1', vSelect)

Vue.use(VueFilterDateFormat, {
  monthNames: [
    'January', 'February', 'March', 'April', 'May', 'June',
    'July', 'August', 'September', 'October', 'November', 'December'
  ],
  monthNamesShort: [
    'Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun',
    'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'
  ]
})

import vueDebounce from 'vue-debounce'

Vue.use(vueDebounce, {
  lock: false,
  defaultTime: '700ms'
})



import 'bootstrap'
Vue.component('pagination', require('laravel-vue-pagination'))
// Sync store with router
sync(store, router)

Vue.config.productionTip = false
Vue.use(Toasted,{
  theme: "toasted-primary",
  position: "bottom-center",
  duration : 5000,
})

// navigation guards before each
router.beforeEach((to, from, next) => {

  if (to.matched.some(record => record.meta.requiresAuth)) {
    // this route requires auth, check if logged in
    // if not, redirect to login page.
    if (sessionStorage.getItem('AUTH_TOKEN') === null) {
      next({
        path: '/session/login',
        query: { redirect: to.fullPath }
      })
    } else {
      next()
    }
  } else {
    next() // make sure to always call next()!
  }
})

if (sessionStorage.getItem('AUTH_TOKEN') != null) {
  router.push("/list");
}else{
  router.push("/session/login");
}

/* eslint-disable no-new */
new Vue({
  i18n,
  router,
  store,
  render: h => h(App)
}).$mount('#app')
